import { render, staticRenderFns } from "./backoffice-motivo-recusa-orcamento.vue?vue&type=template&id=5842923c"
import script from "./backoffice-motivo-recusa-orcamento.vue?vue&type=script&lang=ts"
export * from "./backoffice-motivo-recusa-orcamento.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports